import { Item } from "@coworker/apprestructured/src/shared/types/item";
import styles from "./SelectedArticles.module.css";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import TrashCanIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/TrashCanIconPath";
import { useUserPreference } from "@coworker/app/src/hooks/useProfilePreferencesQuery";
import profilePreferences from "@coworker/enums/profilePreferences";
import { SelectedItemCard } from "@coworker/apprestructured/src/task-management/components/AttachArticles/SelectedItemCard/SelectedItemCard";

interface SelectedArticlesProps {
  items: Item[];
  onDeleteArticle: (no: string) => void;
}

export const SelectedArticles = ({
  items,
  onDeleteArticle,
}: SelectedArticlesProps) => {
  const [searchHistory, setSearchHistory] = useUserPreference<string[]>(
    profilePreferences.SEARCH_HISTORY,
    []
  );
  return (
    <ul className={styles["ul"]}>
      {items.map((article) => (
        <li key={article.no} className={styles["li"]}>
          <SelectedItemCard
            item={article}
            setSearchHistory={setSearchHistory}
            searchHistory={searchHistory}
            handleProductClick={() => {}}
          />
          <FixaButton
            type="secondary"
            iconOnly
            ssrIcon={TrashCanIconPath}
            size="small"
            onClick={() => onDeleteArticle(article.no)}
          />
        </li>
      ))}
    </ul>
  );
};
